import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../cms/block/abstract-cms-block.component';

export interface ICheckoutResultContentBlockData extends NICmsContentComponent.IData {
    sagepay_color_depth_error_message?: string;
}

@Component({
    selector: 'checkout-result-content-block',
    template: '<ng-content />',
    standalone: true,
    imports: [CommonModule]
})
@ICmsComponent<CheckoutResultContentBlockComponent>({
    id: 'checkout-result-content-block',
    block: {
        url: 'checkout-result-content-block'
    },
    onDemandOnly: true,
    name: 'Checkout Result Content Block',
    description: 'Content block used for checkout result',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'sagepay_color_depth_error_message',
            title: 'Sagepay color depth error message'
        }
    ]
})
export class CheckoutResultContentBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: ICheckoutResultContentBlockData;

    override canDetach = false;
}
